// Export all registries and their types
export { ContentRegistry, type ContentItemProps } from './ContentRegistry';
export { ActionRegistry, type ActionHandler, type ValidationResult } from './ActionRegistry';
export { ContextRegistry, type ContextExtractor } from './ContextRegistry';
export { InspectViewRegistry, type InspectViewProps } from './InspectViewRegistry';

// Deferred initialization to avoid circular dependencies
let isInitialized = false;

async function initializeInspectViews() {
  if (isInitialized) return;

  try {
    // Dynamic imports to break circular dependency
    const [
      { BlogInspectImmersive },
      { GuestLoginInspectView },
      { ImageInspectView },
      { ProductInspectView },
      { default: MembershipInspectView },
    ] = await Promise.all([
      import('../inspect-views/BlogInspectImmersive'),
      import('../inspect-views/GuestLoginInspectView'),
      import('../inspect-views/ImageInspectView'),
      import('../inspect-views/ProductInspectView'),
      import('../inspect-views/MembershipInspectView'),
    ]);

    const { InspectViewRegistry } = await import('./InspectViewRegistry');

    // Register inspect views
    InspectViewRegistry.register('blog', BlogInspectImmersive);
    InspectViewRegistry.register('product', ProductInspectView);
    InspectViewRegistry.register('image', ImageInspectView);
    InspectViewRegistry.register('guest-login', GuestLoginInspectView);
    InspectViewRegistry.register('membership', MembershipInspectView);

    isInitialized = true;
    console.log('🚀 Ambient Intelligence Registries initialized');
  } catch (error) {
    console.error('❌ Failed to initialize inspect views:', error);
  }
}

// Initialize on next tick to avoid circular dependency
if (typeof window !== 'undefined') {
  // Client-side initialization
  setTimeout(initializeInspectViews, 0);
} else {
  // Server-side - defer until needed
  initializeInspectViews();
}

// Export initialization function for manual triggering if needed
export { initializeInspectViews };
